//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './PrivilegedModeTotpClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export function enableUrl(): string {
  let url_ = getBaseUrl() + "/api/privileged-mode/totp/enable";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function enableMutationKey(): MutationKey {
  return trimArrayEnd([
      'PrivilegedModeTotpClient',
      'enable',
    ]);
}

export function useEnableMutation<TContext>(options?: Omit<UseMutationOptions<Types.PrivilegedModeTotpEnableResponseDto, unknown, Types.PrivilegedModeTotpEnableRequestDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PrivilegedModeTotpEnableResponseDto, unknown, Types.PrivilegedModeTotpEnableRequestDto, TContext> {
  const key = enableMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PrivilegedModeTotpEnableRequestDto) => Client.enable(dto),
    mutationKey: key,
  });
}